<div class="container-fluid mt-4">
    <h4 class="mb-3 "><i class="fi fi-rr-newspaper"></i> სლაიდი <span *ngIf="currentLang == 'en'">(EN)</span> </h4>
    <div class="row">
        <div class="col-md-3"> 
          <button class="btn btn-primary" (click)="add()">
              დამატება 
          </button>
        </div>
    </div>


    <div class="row g-4">
      <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>
    </div>

    <div *ngIf="!load && (!data || data.length === 0)">
      ინფორმაცია ცარიელია
    </div>

    <div *ngIf="!load" 
        cdkDropList 
        [cdkDropListData]="data" 
        (cdkDropListDropped)="drop($event)" 
        class="list-group mt-3">

      <div *ngFor="let item of data; let i = index" 
          cdkDrag 
          class="list-group-item mb-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <span class="me-3">{{ i + 1 }}</span>
          <img *ngIf="item.image1 && item.image1.trim() !== ''" 
              [src]="getFullImageUrl(item.image1)" 
              class="square-img me-3">
          <span class="truncate-text">{{ item.title }}</span>
        </div>
        <div class="d-flex">

          <button *ngIf="loadDeleteId !== item.id" (click)="delete(item)" class="btn text-danger border btn-sm">
            <i *ngIf="loadDeleteId !== item.id" class="fi fi-rr-trash"></i>
            <app-spinner *ngIf="loadDeleteId === item.id" [loading]="true"></app-spinner>
          </button>


          <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="edit(item)">
            <i class="fi fi-rr-pencil"></i>
          </button>
        </div>
      </div>

    </div>

</div>


<ng-template #formModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <span *ngIf="isEdit">სლაიდის რედაქტირება</span>
      <span *ngIf="!isEdit">სლაიდის დამატება</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">

      <form [formGroup]="form">

        
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            formControlName="title"
            id="title"
            placeholder=""
            required>
          <label for="title">სათაური</label>
          <div class="invalid-feedback">
            error
          </div>
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-slug">http:</span>
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="link"
              id="link"
              placeholder="ბმული"
              required>
            <label for="link">ბმული</label>
          </div>
        </div>


        <div class="form-check form-switch mb-3">
          <input type="checkbox" class="form-check-input" id="show_title" formControlName="show_title">
          <label class="form-check-label" for="show_title"> სათაური გამოჩენა</label>
        </div>



        <div class="mt-3 mb-3">
          
          <div class="d-flex align-items-start flex-column gap-3">

            <img
              *ngIf="form.get('image1')?.value"
              [src]="getFullImageUrl(form.get('image1')?.value)"
              alt="არჩეული სურათი"
              class="img"
            />

          <button type="button" class="btn btn-primary" (click)="openFileManagerForImage()">
              <i class="fi fi-rr-picture"></i> 
              <span *ngIf="form.get('image1')?.value"> სურათის შეცვლა</span>
              <span *ngIf="!form.get('image1')?.value"> სურათის არჩევა</span>
            </button>
            
          </div>
        </div>
        
        <div class="form-check form-switch mb-3">
          <input type="checkbox" class="form-check-input" id="visibility" formControlName="visibility">
          <label class="form-check-label" for="visibility"> გამოჩენა</label>
        </div>

      </form>

  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary d-flex" (click)="save(modal)" [disabled]="editBtnLoad">
      <app-spinner [sm]="true" [loading]="editBtnLoad"></app-spinner> 
      <span *ngIf="isEdit">შენახვა</span>
      <span *ngIf="!isEdit">დამატება</span>
    </button>
  </div>
</ng-template>


<ng-template #fileManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ფაილის არჩევა</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-file-manager
      [type]="'image'"
      (fileSelected)="onFileSelectedFromManager($event, modal)">
    </app-file-manager>
  </div>
</ng-template>